/* eslint-disable */
import { useState, useEffect } from "react";
import { defineMessages, MessageDescriptor } from "react-intl";

const PREFIX = "PasswordValidator";
export const passwordValidatorMessages = defineMessages({
  isRequired: {
    id: `${PREFIX}.isRequired`,
    defaultMessage: "The field is required",
  },
  mustMatch: {
    id: `${PREFIX}.mustMatch`,
    defaultMessage: "New password does not meet the specified requirements",
  },
  maxLength: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the length of the entered data",
  },
});

export const passwordPatt = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#\$%\^&\*()\-_=+|\[\]{};:'"\/?.,><])(?=.{8,})/;
export const MIN_PASSWORD_LENGTH = 6;

export function passwordValidate(password: string | undefined | null, useMatch = true) {
  const errors: MessageDescriptor[] = [];
  if (password !== undefined && password !== null) {
    if (!password.length) {
      errors.push(passwordValidatorMessages.isRequired);
    }
    if (useMatch && !password.match(passwordPatt)) {
      errors.push(passwordValidatorMessages.mustMatch);
    }
    if (password.length < MIN_PASSWORD_LENGTH) {
      errors.push(passwordValidatorMessages.maxLength);
    }
  }
  return errors;
}

const initState = {
  valid: true,
  errors: [] as MessageDescriptor[],
};

export type UsePasswodValue = string | undefined | null;
export type UsePasswodValidatorResult = [boolean, MessageDescriptor[]];
export function usePasswordValidator(password: UsePasswodValue, useMatch?: boolean): UsePasswodValidatorResult {
  const [state, setState] = useState(initState);
  useEffect(() => {
    const errors = passwordValidate(password, useMatch);
    setState({
      valid: !errors.length,
      errors,
    });
  }, [password]);
  return [state.valid, state.errors];
}
